import {
    Box,
    Button,
    Flex,
    Heading,
    Menu,
    MenuButton,
    Modal,
    ModalOverlay,
    // Select,
    Text,
    useDisclosure,
    MenuList,
    MenuItem
} from '@chakra-ui/react'
import { BsPlusLg } from "react-icons/bs";
import { AiOutlineDown } from "react-icons/ai";
import { AiOutlineSearch } from "react-icons/ai";
import { GrShare  } from "react-icons/gr";
import React, { Fragment } from 'react'
import UserForm from '../UserForm';
import SettlementForm from '../SettlementForm'
import DisputeForm from '../DisputeForm'
// import ReturnForm from '../ReturnForm'
// import OrderDeliveryForm from '../OrderDeliveryForm'
import OrderReturnForm from '../OrderReturnForm'
import { Link } from 'react-router-dom';
import OrderSearchModal from '../OrderSearchModal';
import CustomerSearchModal from '../CustomerSearchModal';
const AllFillters = ({ title, data, filters, create, filterId, renderData, title2 }) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    //  const resultPerPage = [20,30,40,50,60,70,80,90,100]

    return (
        <Fragment>
            <Box>
                <Flex justifyContent={'space-between'} alignItems={'center'} mt={{base: 2, md: 2, lg: 2, xl: 0, '2xl': 0}}>
                    {title === 'All Notifications' ? 
                    <Heading fontSize={{base: '20px', md: '20px', lg: '27px', xl: '27px', '2xl': '27px'}} mb={0} >{title2}</Heading>
                    :
                    <Heading fontSize={{base: '20px', md: '20px', lg: '27px', xl: '27px', '2xl': '27px'}} mb={0} >{title !== 'Main All Returns' ? title : 'All Returns'}</Heading>
                    }
                    <Flex justifyContent={{base: 'none', md: 'none', lg: 'space-between', xl: 'space-between', '2xl': 'space-between'}}>
                        {/* ------ add button modal open --------*/}
                        {/* Order */}   

                        {/* SEARCH ORDER */}
                        {(create === 'Order' || create === 'Delivery Boy')  && (
                        <>
                        <Button colorScheme={'green'} rounded={'full'} mx={2} fontSize={'15px'} onClick={onOpen} >
                        <AiOutlineSearch mt={1} fontSize={'19px'}/>
                        <Text display={{base: 'none', md: 'none', lg: 'block', xl: 'block', '2xl': 'block'}} ml={2} mr={2}> Search Order </Text>
                        </Button>
                        </>
                         )}

                         {/* SEARCH CUSTOMER */}
                        {(create === 'Cutomer Verification')  && (
                        <>
                        <Button colorScheme={'green'} rounded={'full'} mx={2} fontSize={'15px'} onClick={onOpen} >
                        <AiOutlineSearch mt={1} fontSize={'19px'}/>
                        <Text display={{base: 'none', md: 'none', lg: 'block', xl: 'block', '2xl': 'block'}} ml={2} mr={2}> Search Customer </Text>
                        </Button>
                        </>
                         )}

                        {/* CREATE ORDER */}
                        {create === 'Order'  && (
                        <>
                        <Link to={'/orders/create'}>
                        <Button colorScheme={'blue'} rounded={'full'} mx={2} fontSize={'15px'} >
                        <Text display={{base: 'none', md: 'none', lg: 'block', xl: 'block', '2xl': 'block'}} mr={2}> Create {create} </Text> <BsPlusLg mt={1} fontSize={'12px'}/>
                        </Button>
                        </Link>
                        </>
                         )}
                         {/* Dispute */}
                         {title === 'All Disputes' && 
                        <Button rightIcon={<BsPlusLg />} colorScheme={'blue'} rounded={'full'} mx={2} onClick={onOpen} fontSize={'15px'}>
                            Add Dispute
                        </Button>
                         }
                          {/* Order Delivery */}
                          {/* {title === 'All Deliveries' && 
                        <Button  colorScheme={'blue'} rounded={'full'} mr={{base: 0, md: 0, lg: 2, xl: 2, '2xl': 2}} onClick={onOpen} fontSize={'15px'} >
                            <Text display={{base: 'none', md: 'none', lg: 'block', xl: 'block', '2xl': 'block'}} mr={2}>Create Delivery</Text><BsPlusLg mt={1} fontSize={'12px'}/>
                        </Button>
                         } */}
                          {/* Return Pick up */}
                          {/* {title === 'All Returns' && 
                        <Button  colorScheme={'blue'} rounded={'full'} mx={2} onClick={onOpen} fontSize={'15px'}>
                            <Text display={{base: 'none', md: 'none', lg: 'block', xl: 'block', '2xl': 'block'}} mr={2}>Create Returns</Text><BsPlusLg mt={1} fontSize={'12px'}/>
                        </Button>
                         } */}
                         {/* Return Pick up */}
                         {title === 'Main All Returns' && 
                        <Button rightIcon={<BsPlusLg />} colorScheme={'blue'} rounded={'full'} mx={2} onClick={onOpen} fontSize={'15px'}>
                            Add Returns
                        </Button>
                         }
                         {/* Settlements */}
                         {title === 'All Settlements' && 
                         <>
                        <Button rightIcon={<BsPlusLg />} colorScheme={'blue'} rounded={'full'} mx={2} onClick={onOpen} fontSize={'15px'}>
                            Add Settlement
                        </Button>
                        <Menu>
                            <MenuButton as={Button} bgColor={"white"} shadow={'md'} rounded={'full'} mx={2} variant={'outline'} rightIcon={<AiOutlineDown/> } >
                                Settlement Type
                            </MenuButton>
                            <MenuList>
                                <MenuItem>No Damage</MenuItem>
                                <MenuItem>Minor Damage</MenuItem>
                                <MenuItem>Major Damage</MenuItem>
                            </MenuList>
                        </Menu>
                        </>}
                        <Box>
                        {title !== 'All Deliveries' &&
                        filters?.map((filter,i) => (
                            // <Button letterSpacing={'0.5px'} fontSize={{base: '11px', md: '11px', lg: '17px', xl: '17px', '2xl': '17px'}} shadow={'md'} rounded={'full'} mx={2} mr={{base: 0, md: 0, lg: 2, xl: 2, '2xl': 2}}  px={{base: '11px', md: '11px', lg: '16px', xl: '16px', '2xl': '16px'}}  bgColor={'white'} variant={'outline'}
                            //     onClick={filter[Object.keys(filter)[0]]} key={i} >
                            //     {Object.keys(filter)[0]}
                            //     <Text as="span" mt={'4.5px'} ml={'2.9px'}>
                            //      <AiOutlineDown/>
                            //     </Text> 
                            // </Button>
                           
                            <Menu key={i} >
                            <MenuButton as={Button} rightIcon={<AiOutlineDown/>} bgColor={'white'} variant={'outline'} rounded={'full'} shadown={'md'}>
                                {Object.keys(filter)[0]}
                            </MenuButton>
                            <MenuList zIndex={199}>
                                {Object.values(filter)[0].map((d,index) => {
                                    return (
                                    <MenuItem key={index} onClick={() => filterId(d.id, d.title)}>
                                        {d.title}
                                    </MenuItem>
                                    )
                                })}
                            </MenuList>
                            </Menu>
                        ))}
                        {title === 'All User Access' &&
                         <Button rightIcon={<BsPlusLg fontSize={'14px'}/>} colorScheme={'blue'} rounded={'full'} mx={2} onClick={onOpen} fontSize={'15px'}>Add Member</Button>
                         }
                        {title !== 'All Notifications' &&
                        <Button  bgColor={"white"} shadow={'md'} rounded={'full'} mx={2} variant={'outline'} fontSize={{base: '10px', md: '10px', lg: '15px', xl: '15px', '2xl': '15px'}} py={{base: '10px', md: '10px', lg: '16px', xl: '16px', '2xl': '16px'}} marginRight={{base: '0px', md: '0px', lg: '8px', xl: '8px', '2xl': '8px'}} px={{base: '10px', md: '10px', lg: '16px', xl: '16px', '2xl': '16px'}}>
                            <Text display={{base: 'none', md: 'none', lg: 'block', xl: 'block', '2xl': 'block'}} mr={{base: 0, md: 0, lg: 2, xl: 2, '2xl': 2}}>Export</Text><GrShare  />
                        </Button>
                        }
                        {/* {title === 'All Notifications' &&
                            <Button size={'lg'} variant={'outline'} rounded={'full'} color={'black'} bgColor={'white'} shadow={'md'} rightIcon={<AiFillFilter/>}>Filter</Button>
                        } */}
                        </Box>
                    </Flex>
                </Flex>
                {title !== 'All Notifications' &&
                <Flex justifyContent={'space-between'} mt={{base: 2, md: 2, lg: 3, xl: 3, '2xl': 3}} mr={{base: 0, md: 0, lg: 2, xl: 2, '2xl': 2}} >
                    <Flex alignItems={'end'} flexBasis={{base: '45%', md: '45%', lg: '80%', xl: '80%', '2xl': '80%'}}>
                    <Text fontSize={{base: '12px', md: '12px', lg: '15px', xl: '15px', '2xl': '15px'}} >
                        Showing {data.length} of 1,000 results
                    </Text>
                    </Flex>
                    
                    {/* <Flex alignItems={'center'}  justifyContent={'end'} flexBasis={{base: '55%', md: '55%', lg: '20%', xl: '20%', '2xl': '20%'}}>
                        <Text fontSize={'12px'} mx={3} flexBasis={'60%'} fontWeight={'semibold'} textAlign={'right'} display={{base: 'none', md: 'none', lg: 'block', xl: 'block', '2xl': 'block'}}>Results per page</Text>
                        <Select placeholder="10"  border={'1.5px solid rgba(0, 0, 0, 0.6)'} size={'xs'} flexBasis={'40%'} rounded={'full'}>
                            {resultPerPage.map((e,i) => (<option key={i}>{e}</option>))}
                        </Select>
                    </Flex> */}
                </Flex>
                }
            </Box>
            {/* Modal for form */}
            <Modal
                isOpen={isOpen}
                onClose={onClose}
                size={((create === "Order") || (create === 'Cutomer Verification')) ? '6xl' : '2xl' }
            >
                <ModalOverlay />
               {/* ------------------- Create Order Form Handling & Validation ------------------------- */}
               {/* {create === 'Order' &&      <OrderForm onClose={onClose} title={title} create={create} allOrderState={allOrderState} createdOrderState={createdOrderState} /> }        */}

               {/* // ---------------- Create Member Form Handling & Validation ------------------------ */}
               {title === 'All User Access' && <UserForm onClose={onClose} renderData={renderData}/>  }             

               {/* // ---------------- Create Settlement Form Handling & Validation ------------------------ */}
               {title === 'All Settlements' && <SettlementForm onClose={onClose} /> }           

               {/* // ---------------- Create Dispute Form Handling & Validation ------------------------ */}
               {title === 'All Disputes' && <DisputeForm onClose={onClose} /> }   

               {/* // ---------------- Create Return Form Handling & Validation ------------------------ */}
               {/* {title === 'Main All Returns' && <ReturnForm onClose={onClose} /> }           */}

               {/* // ---------------- Create Delivery Form Handling & Validation ------------------------ */}
               {/* {title === 'All Deliveries' && <OrderDeliveryForm onClose={onClose} /> }        */}

               {/* // ---------------- Create Order Return - Delivery Boy Form Handling & Validation ------------------------ */}
               {title === 'All Returns' && <OrderReturnForm onClose={onClose} /> } 
               
                {/* ORDER SEARCH MODAL */}
                {(create === "Order" || create === 'Delivery Boy') && <OrderSearchModal onClose={onClose} create={create}/>}

                {/* CUSTOMER SEARCH MODAL */}
                {(create === 'Cutomer Verification') && <CustomerSearchModal onClose={onClose} create={create}/>}
            </Modal>
        </Fragment>
    )
}

export default AllFillters
